const datepickerCss = new CSSStyleSheet();
datepickerCss.insertRule(`
  .fw-btn--primary {
      background-color: #345AA4 !important;
      background-image: none !important;
    }
  `);

/**
 * Provides styles for fw-button.
 * @param element Element to provide styles for.
 */
function provideStyles(element: HTMLElement): void {
    const root = element.shadowRoot;

    if (root !== null && !root.adoptedStyleSheets.includes(datepickerCss)) {
        root.adoptedStyleSheets.push(datepickerCss);
    }
}

/**
 * Provides custom styles for one or multiple fw-button elements.
 * @param elements One or multiple fw-button elements.
 */
export function providePrimaryButtonsStyles(elements: HTMLElement | HTMLElement[]): void {
    if (Array.isArray(elements)) {
        elements.forEach(element => provideStyles(element));
    } else {
        provideStyles(elements);
    }

}
